export default __webpack_public_path__ + "static/media/p2023-12.34652842.jpeg";